// rel="noopener" kept as in the design (noreferrer would hide the referrer from stores/WhatsApp)
/* eslint-disable react/jsx-no-target-blank */
// href="#" (privacy settings link) kept as in the design; the script handles the click
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useHomeText } from '../text';

const SiteFooter = () => {
  const t = useHomeText();
  return (
    <footer id="download" style={{ background: "#0B1240", color: "#FFFFFF" }}>
      <div style={{ maxWidth: "1280px", margin: "0 auto", padding: "0 24px" }}>
        <div style={{ transform: "translateY(-56px)", background: "#FFC93C", color: "#0B1240", borderRadius: "32px", padding: "clamp(24px, 4vw, 44px)", display: "flex", gap: "24px", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px", maxWidth: "560px" }}>
            <h2 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "clamp(28px, 3.2vw, 40px)", lineHeight: "1.25", width: "min(860px, calc(100vw - 48px))" }}>
              <strong>
                {t.footer.yourChildSJourney}
              </strong>
              <br />
            </h2>
          </div>
          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
            <a href="https://play.google.com/store/apps/details?id=com.DMNovaComany.Khotoua&pcampaignid=web_share" target="_blank" rel="noopener" style={{ display: "inline-flex", alignItems: "center", gap: "10px", minHeight: "52px", padding: "0 16px 0 14px", borderRadius: "14px", background: "#0B1240", border: "1px solid rgba(255,255,255,0.25)", color: "#FFFFFF", textDecoration: "none" }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinejoin="round" aria-hidden="true">
                <path d="M5 3.500v17l14-8.500z" />
                <path d="M5 3.500l9 9M5 20.500l9-8.500" opacity="0.6" />
              </svg>
              <span style={{ display: "flex", flexDirection: "column", lineHeight: "1.15", textAlign: "start" }}>
                <span style={{ fontSize: "11px", opacity: "0.8" }}>
                  {t.footer.getItOn}
                </span>
                <span style={{ fontSize: "16px", fontWeight: "800" }} dir="ltr">
                  Google Play
                </span>
              </span>
            </a>
            <a href="#appstore" data-soon={t.footer.getItOnAppSoon} style={{ display: "inline-flex", alignItems: "center", gap: "10px", minHeight: "52px", padding: "0 16px 0 14px", borderRadius: "14px", background: "#0B1240", border: "1px solid rgba(255,255,255,0.25)", color: "#FFFFFF", textDecoration: "none" }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
                <rect x="6" y="2.500" width="12" height="19" rx="3" />
                <path d="M10.500 18.500h3" />
              </svg>
              <span style={{ display: "flex", flexDirection: "column", lineHeight: "1.15", textAlign: "start" }}>
                <span style={{ fontSize: "11px", opacity: "0.8" }}>
                  {t.footer.getItOn}
                </span>
                <span style={{ fontSize: "16px", fontWeight: "800" }} dir="ltr">
                  App Store
                </span>
              </span>
            </a>
            <a href="#appgallery" data-soon={t.footer.getItOnAppgallerySoon} style={{ display: "inline-flex", alignItems: "center", gap: "10px", minHeight: "52px", padding: "0 16px 0 14px", borderRadius: "14px", background: "#0B1240", border: "1px solid rgba(255,255,255,0.25)", color: "#FFFFFF", textDecoration: "none" }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M5 8h14l-1 12H6z" />
                <path d="M9 8V6.500a3 3 0 0 1 6 0V8" />
                <path d="M9.500 12.500a2.500 2.500 0 0 0 5 0" />
              </svg>
              <span style={{ display: "flex", flexDirection: "column", lineHeight: "1.15", textAlign: "start" }}>
                <span style={{ fontSize: "11px", opacity: "0.8" }}>
                  {t.footer.getItOn}
                </span>
                <span style={{ fontSize: "16px", fontWeight: "800" }} dir="ltr">
                  AppGallery
                </span>
              </span>
            </a>
            <a href="https://khotoua.com/KHOTOUA_DEMO/Khotoua%20Inscription%20Portrait.dc.html" target="_blank" rel="noopener" style={{ display: "inline-flex", alignItems: "center", gap: "10px", minHeight: "52px", padding: "0 16px 0 14px", borderRadius: "14px", background: "#0B1240", border: "1px solid rgba(255,255,255,0.25)", color: "#FFFFFF", textDecoration: "none" }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
                <circle cx="12" cy="12" r="9" />
                <path d="M3 12h18M12 3c3 3.500 3 14.500 0 18M12 3c-3 3.500-3 14.500 0 18" />
              </svg>
              <span style={{ display: "flex", flexDirection: "column", lineHeight: "1.15", textAlign: "start" }}>
                <span style={{ fontSize: "11px", opacity: "0.8" }}>
                  {t.footer.tryItOn}
                </span>
                <span style={{ fontSize: "16px", fontWeight: "800" }} dir="ltr">
                  {t.footer.theWeb}
                </span>
              </span>
            </a>
          </div>
        </div>
        {" "}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(220px, 100%), 1fr))", gap: "32px", padding: "8px 0 40px" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            <img width="204" height="130" loading="lazy" decoding="async" src="/assets/img/logo-khotoua.webp" alt={t.footer.khotouaLogoAlt} style={{ height: "64px", width: "auto", alignSelf: "flex-start" }} />
            <span style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontSize: "24px", fontWeight: "800", color: "#FFC93C" }}>
              {t.footer.everyAchievementStartsWith}
            </span>
          </div>
          <nav aria-label={t.footer.aboutUsLearningContentLabel} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <a href="#about" style={{ color: "#DCE0FF", textDecoration: "none" }}>
              {t.footer.aboutUs}
            </a>
            <a href="#contents" style={{ color: "#DCE0FF", textDecoration: "none" }}>
              {t.footer.learningContent}
            </a>
            <a href="#features" style={{ color: "#DCE0FF", textDecoration: "none" }}>
              {t.footer.features}
            </a>
            <a href="#trust" style={{ color: "#DCE0FF", textDecoration: "none" }}>
              {t.footer.testimonials}
            </a>
          </nav>
          <nav aria-label={t.footer.termsAndConditionsPrivacyLabel} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <a href="/privacy" target="_blank" rel="noopener" style={{ color: "#DCE0FF", textDecoration: "none" }}>
              {t.footer.termsAndConditions}
            </a>
            <a href="/privacy" target="_blank" rel="noopener" style={{ color: "#DCE0FF", textDecoration: "none" }}>
              {t.footer.privacyPolicy}
            </a>
            <a href="#contact" style={{ color: "#DCE0FF", textDecoration: "none" }}>
              {t.footer.contact}
            </a>
          </nav>
          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <span style={{ color: "#C9CEF5", fontSize: "14px" }}>
              {t.footer.producedBy}
            </span>
            <a href="https://www.dmnova.tech/" target="_blank" rel="noopener" aria-label={t.footer.dmNovaOfficialWebsiteLabel} style={{ alignSelf: "flex-start", display: "inline-flex", alignItems: "center", padding: "6px 0", minHeight: "44px" }}>
              <img width="640" height="84" loading="lazy" decoding="async" src="/assets/img/dmnova-logo-white.webp" alt="DM NOVA" style={{ height: "28px", width: "auto", display: "block" }} />
            </a>
            <span style={{ color: "#C9CEF5", fontSize: "13px" }} dir="ltr">
              dmnova.tech
            </span>
          </div>
        </div>
        {" "}
        <div style={{ borderTop: "1px solid rgba(255,255,255,0.12)", padding: "20px 0 28px", fontSize: "13px", color: "#A9B1E0" }}>
          {t.footer.t2026KhotouaDmNova}
          <span data-consent-open="">
            {" · "}
            <a href="#" style={{ color: "#A9B1E0" }}>
              {t.footer.privacySettings}
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
